import { gql } from '@apollo/client';

export const UPDATE_GOOD_DEAL_PROMPT = gql`
  mutation UpdateGoodDealPrompts(
    $where: ArticleGoodDealAiPromptUniqueFilterInput!
    $data: ArticleGoodDealAiPromptUpdateInput!
  ) {
    updateArticleGoodDealAiPrompt(where: $where, data: $data) {
      id
    }
  }
`;
